import { Roles } from 'shared/constants/roles';

export const getPermissions = role => {
  switch (role) {
    case Roles.SAAS_ADMIN:
      return {
        'web.admin': 'allow',
        'web.admin.home.pools.pool': 'disallow',
        'web.admin.home.pools.subAccounts': 'disallow',
        'web.admin.home.pools.transactions': 'disallow',
        'web.admin.home.duckEnergyBox.request': 'disallow',
        'web.admin.home.locations': 'disallow',
        'web.admin.customers': 'disallow',
        'web.admin.tasks': 'disallow',
        'web.admin.hardware': 'disallow',
        'web.admin.downloads': 'disallow',
        'web.admin.settings': 'disallow'
      };
    case Roles.TENANT_ADMIN:
      return {
        'web.admin': 'allow',
        'web.admin.home.fundamentals': 'disallow',
        'web.admin.home.pools.add': 'disallow',
        'web.admin.home.paymentProviders.add': 'disallow',
        'web.admin.home.duckEnergyBox.add': 'disallow',
        'web.admin.tenants': 'disallow'
      };
    case Roles.SRE:
      return {
        'web.admin': 'allow',
        'web.admin.home.dashboard.total-energy-consumption-chart': 'disallow',
        'web.admin.home.fundamentals': 'disallow',
        'web.admin.home.pools.add': 'disallow',
        'web.admin.home.paymentProviders.add': 'disallow',
        'web.admin.home.duckEnergyBox.add': 'disallow',
        'web.admin.tenants': 'disallow'
      };
    default:
      return {
        'web.admin': 'allow'
      };
  }
};
